import { ElectronicInvoiceSender } from 'src/modules/invoice/models/electronicInvoiceSender';
import { RegisterSenderRequest } from 'src/modules/admin/invoice/models/registerSenderRequest';
import AxiosInstance from './axios/interceptor';

const controller = 'ElectronicInvoiceSender';

export const getEInvoiceSender = (ownerId: number) => {
  return AxiosInstance.get<ElectronicInvoiceSender>(`${controller}?owner_id=${ownerId}`);
};

export const registerEInvoiceSender = (data: RegisterSenderRequest) => {
  return AxiosInstance.post<ElectronicInvoiceSender>(`${controller}/Register`, data);
};

export const deleteEInvoiceSender = (ownerId: number) => {
  return AxiosInstance.delete(`${controller}/${ownerId}`);
};
